<template>
  <div class="d2c-your-detail__container">
    <BaseButton
      :text="LABEL_CONSTANTS.BACK_TO_COVER_TYPE"
      flat
      ripple
      class="font-weight-semi-bold d-flex back-btn back-previous__btn-link pa-0 mb-sm-5"
      icon="mdi-chevron-left"
      color="#106175"
      small
      @click="backToCoverType"
    />
    <!-- Stepper Title -->
    <v-row class="mb-5">
      <v-col class="d-flex justify-space-between flex-wrap section-title">
        <div>
          <h1 class="font-28 font-weight-bold black2-color">Your details</h1>
        </div>
        <BaseButton
          text="Save &amp; exit"
          flat
          depressed
          ripple
          class="font-weight-semi-bold d2c-save-exit mt-2 mr-2 py-3 d-flex"
          icon="mdi-content-save"
          color="#106175"
          small
          @click="saveAndExit"
        />
      </v-col>
    </v-row>
    <ValidationObserver ref="observerFormDetails">
      <v-form ref="submitForm">
        <v-row>
          <v-col cols="12" xl="6" class="py-0 title-select">
            <BaseLabel
              :text="LABEL_CONSTANTS.TITLE_LABEL"
              :helpText="LABEL_CONSTANTS.TITLE_HELP_TEXT"
            />
            <BaseSelect
              dense
              v-model="questionApplicant1Title.Value"
              :items="applicant1TitleOptions"
              :data-uiid="questionApplicant1Title.InterfaceKey"
              :isEnableSortOrderListItems="false"
              :hide-details="false"
              :selectedDefault="LABEL_CONSTANTS.SELECT_DEFAULT_PLACEHOLDER"
              :rules="{
                required: {
                  required: true,
                  fieldLabel: LABEL_CONSTANTS.TITLE_LABEL,
                },
              }"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" xl="6" class="py-0">
            <BaseLabel :text="LABEL_CONSTANTS.FIRST_NAME_LABEL" />
            <BaseInput
              vid="Applicant1Forename"
              v-model="questionApplicant1Forename.Value"
              :data-uiid="questionApplicant1Forename.InterfaceKey"
              :hide-details="false"
              :rules="applicantFirstNameRules"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" xl="6" class="py-0">
            <BaseLabel :text="LABEL_CONSTANTS.LAST_NAME_LABEL" />
            <BaseInput
              vid="Applicant1Surname"
              v-model="questionApplicant1Surname.Value"
              :data-uiid="questionApplicant1Surname.InterfaceKey"
              :hide-details="false"
              :rules="applicantLastNameRules"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" xl="6" class="py-0">
            <BaseLabel
              :text="LABEL_CONSTANTS.DATE_OF_BIRTH_LABEL"
              label-class="font-18 font-weight-medium mb-1"
            />
            <BaseInputDate
              vid="Applicant1DoB"
              :data-uiid="questionApplicant1DoB.InterfaceKey"
              :value="questionApplicant1DoB.Value"
              v-model="questionApplicant1DoB.Value"
              :rules="applicantDateOfBirthRules"
              styleClass="d2c-date-input"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" xl="6" class="py-0">
            <BaseLabel
              :text="LABEL_CONSTANTS.OCCUPATION_LABEL"
              :hintText="LABEL_CONSTANTS.OCCUPATION_HINT_HELP_TEXT"
            />
            <BaseAutocomplete
              vid="Applicant1Occupation"
              v-model="questionApplicant1Occupation.Value"
              :data-uiid="questionApplicant1Occupation.InterfaceKey"
              :items="allOccupations"
              :hide-details="false"
              placeholder="Start typing…"
              :noDataMatchingMessage="
                LABEL_CONSTANTS.NO_MATCHING_DATA_OCCUPATION
              "
              :rules="{
                required: {
                  required: true,
                  fieldLabel: 'Job title',
                },
              }"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" xl="6" class="py-0">
            <BaseLabel
              :text="LABEL_CONSTANTS.INDUSTRY_LABEL"
              :helpText="LABEL_CONSTANTS.INDUSTRY_HELP_TEXT"
              :hintText="LABEL_CONSTANTS.INDUSTRY_HINT_TEXT"
            />
            <BaseAutocomplete
              vid="Applicant1Industry"
              v-model="questionApplicant1Industry.Value"
              :data-uiid="questionApplicant1Industry.InterfaceKey"
              :items="allIndustries"
              :hide-details="false"
              placeholder="Start typing…"
              :noDataMatchingMessage="LABEL_CONSTANTS.NO_MATCHING_DATA_INDUSTRY"
              :rules="{
                required: {
                  required: true,
                  fieldLabel: 'Industry',
                },
              }"
            />
          </v-col>
        </v-row>

        <v-row class="mb-7">
          <v-col cols="12" class="py-0 second-applicant-included-field">
            <BaseLabel
              :text="LABEL_CONSTANTS.SECOND_APPLICANT_INCLUDED_LABEL"
              :helpText="LABEL_CONSTANTS.SECOND_APPLICANT_INCLUDED_HELP_TEXT"
              labelClass="mb-2 font-18 font-weight-medium"
            />
            <BaseToggle
              :label="LABEL_CONSTANTS.SECOND_APPLICANT_INCLUDED_LABEL_TOGGLE"
              v-model="questionSecondApplicantIncluded.Value"
              pslStyle="button"
              :data-uiid="questionSecondApplicantIncluded.InterfaceKey"
            />
          </v-col>
        </v-row>

        <template v-if="questionSecondApplicantIncluded.Value">
          <v-row>
            <v-col cols="12" xl="6" class="py-0 title-select">
              <BaseLabel
                :text="LABEL_CONSTANTS.TITLE_LABEL"
                :helpText="LABEL_CONSTANTS.TITLE_HELP_TEXT"
              />
              <BaseSelect
                vid="Applicant2Title"
                v-model="questionApplicant2Title.Value"
                :items="applicant2TitleOptions"
                :data-uiid="questionApplicant2Title.InterfaceKey"
                :isEnableSortOrderListItems="false"
                :hide-details="false"
                :selectedDefault="LABEL_CONSTANTS.SELECT_DEFAULT_PLACEHOLDER"
                :rules="{
                  required: {
                    required: true,
                    fieldLabel: LABEL_CONSTANTS.TITLE_LABEL,
                  },
                }"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" xl="6" class="py-0">
              <BaseLabel :text="LABEL_CONSTANTS.FIRST_NAME_LABEL" />
              <BaseInput
                vid="Applicant2Forename"
                v-model="questionApplicant2Forename.Value"
                :data-uiid="questionApplicant2Forename.InterfaceKey"
                :hide-details="false"
                :rules="applicantFirstNameRules"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" xl="6" class="py-0">
              <BaseLabel :text="LABEL_CONSTANTS.LAST_NAME_LABEL" />
              <BaseInput
                vid="Applicant2Surname"
                v-model="questionApplicant2Surname.Value"
                data-uiid="Applicant2Surname"
                :hide-details="false"
                :rules="applicantLastNameRules"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" xl="6" class="py-0">
              <BaseLabel
                :text="LABEL_CONSTANTS.DATE_OF_BIRTH_LABEL"
                label-class="font-18 font-weight-medium mb-1"
              />
              <BaseInputDate
                vid="Applicant2DoB"
                :data-uiid="questionApplicant2DoB.InterfaceKey"
                :value="questionApplicant2DoB.Value"
                v-model="questionApplicant2DoB.Value"
                :rules="applicantDateOfBirthRules"
                styleClass="d2c-date-input"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" xl="6" class="py-0">
              <BaseLabel
                :text="LABEL_CONSTANTS.SECOND_OCCUPATION_LABEL"
                :hintText="LABEL_CONSTANTS.SECOND_OCCUPATION_HINT_HELP_TEXT"
              />
              <BaseAutocomplete
                vid="Applicant2Occupation"
                :data-uiid="questionApplicant2Occupation.InterfaceKey"
                :hide-details="false"
                :items="allOccupations"
                v-model="questionApplicant2Occupation.Value"
                placeholder="Start typing…"
                :noDataMatchingMessage="
                  LABEL_CONSTANTS.NO_MATCHING_DATA_OCCUPATION
                "
                :rules="{
                  required: {
                    required: true,
                    fieldLabel: 'Job title',
                  },
                }"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" xl="6" class="py-0">
              <BaseLabel
                :text="LABEL_CONSTANTS.SECOND_INDUSTRY_LABEL"
                :helpText="LABEL_CONSTANTS.SECOND_INDUSTRY_HELP_TEXT"
                :hintText="LABEL_CONSTANTS.SECOND_INDUSTRY_HINT_TEXT"
              />
              <BaseAutocomplete
                vid="Applicant2Industry"
                v-model="questionApplicant2Industry.Value"
                :data-uiid="questionApplicant2Industry.InterfaceKey"
                :items="allIndustries"
                :hide-details="false"
                placeholder="Start typing…"
                :noDataMatchingMessage="
                  LABEL_CONSTANTS.NO_MATCHING_DATA_INDUSTRY
                "
                :rules="{
                  required: {
                    required: true,
                    fieldLabel: 'Industry',
                  },
                }"
              />
            </v-col>
          </v-row>
        </template>

        <v-row class="mb-7">
          <v-col cols="12" xl="8" class="py-0">
            <BaseLabel
              :text="LABEL_CONSTANTS.PREVIOUS_LANDLORDS_COVER"
              :helpText="LABEL_CONSTANTS.PREVIOUS_LANDLORDS_COVER_HELP_TEXT"
              labelClass="mb-2 font-18 font-weight-medium"
            />
            <BaseToggleButton
              height="48"
              minWidth="110px"
              v-model="questionPreviousLandlordsCover.Value"
              pslStyle="button"
              :data-uiid="questionPreviousLandlordsCover.InterfaceKey"
              :toggleButtonText="{
                yesDataUiid: `${questionPreviousLandlordsCover.InterfaceKey}_Yes`,
                noDataUiid: `${questionPreviousLandlordsCover.InterfaceKey}_No`,
              }"
            />
          </v-col>
        </v-row>

        <v-row class="mb-6">
          <v-col cols="12" xl="7" class="py-0">
            <BaseLabel
              :text="LABEL_CONSTANTS.NO_OF_RENTAL_PROPERTIES_LABEL"
              :helpText="
                LABEL_CONSTANTS.NO_OF_RENTAL_PROPERTIES_LABEL_HELP_TEXT
              "
              labelClass="mb-2 font-18 font-weight-medium"
            />
            <BaseRadio
              className="radio-renta-propertise"
              :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
              :width="$vuetify.breakpoint.lgAndUp ? '72' : '100'"
              :style="{
                'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
              }"
              v-model="questionNoOfRentalProperties.Value"
              pslStyle="button"
              :items="noRetailRentalOptions"
              :rules="{
                required: {
                  required: true,
                  fieldLabel: LABEL_CONSTANTS.NO_OF_RENTAL_PROPERTIES_LABEL,
                },
              }"
              :data-uiid="questionNoOfRentalProperties.InterfaceKey"
            />
          </v-col>
          <v-col
            cols="12"
            class="py-0"
            v-if="!isQuestionNoOfRentalPropertiesValid"
          >
            <v-alert
              color="var(--red-100)"
              class="mt-4 mb-1 py-2 d-inline-block"
            >
              <div class="d-flex flex-no-wrap">
                <div class="mr-3">
                  <v-icon color="var(--red-500)">mdi-alert-circle</v-icon>
                </div>
                <p class="mb-0">
                  <span class="font-weight-bold">Sorry!</span>
                  We are not able to provide a quote at this time if you own
                  more than 10 properties.
                </p>
              </div>
            </v-alert>
          </v-col>
        </v-row>

        <v-row class="mb-8">
          <v-col cols="12" xl="10" class="py-0">
            <BaseLabel
              :text="LABEL_CONSTANTS.UNAPPROVED_MORTGAGE_APPLICATION"
              :helpText="
                LABEL_CONSTANTS.UNAPPROVED_MORTGAGE_APPLICATION_HELP_TEXT
              "
              labelClass="mb-2 font-18 font-weight-medium"
            />
            <BaseToggleButton
              height="48"
              minWidth="110px"
              v-model="questionUnapprovedMortgageApplication.Value"
              pslStyle="button"
              :data-uiid="questionUnapprovedMortgageApplication.InterfaceKey"
              :toggleButtonText="{
                yesDataUiid: `${questionUnapprovedMortgageApplication.InterfaceKey}_Yes`,
                noDataUiid: `${questionUnapprovedMortgageApplication.InterfaceKey}_No`,
              }"
            />
          </v-col>
        </v-row>

        <v-row class="mb-6">
          <v-col cols="12" xl="10" class="py-0">
            <BaseLabelDialog
              :text="LABEL_CONSTANTS.PREVIOUS_CLAIM_LABEL"
              :hintText="LABEL_CONSTANTS.PREVIOUS_CLAIM_HINT_TEXT"
              dialog-component-name="DialogContentLandlordInsuranceClaim"
              @showModal="showModal"
            />
            <BaseToggleButton
              height="48"
              minWidth="110px"
              v-model="questionPreviousClaim.Value"
              pslStyle="button"
              :data-uiid="questionPreviousClaim.InterfaceKey"
              :toggleButtonText="{
                yesDataUiid: `${questionPreviousClaim.InterfaceKey}_Yes`,
                noDataUiid: `${questionPreviousClaim.InterfaceKey}_No`,
              }"
            />
          </v-col>
        </v-row>
        <v-row v-if="!isClaimFormValid">
          <v-col>
            <v-alert
              dense
              text
              type="error"
              icon="mdi-alert-circle"
              class="mb-4"
            >
              <span class="black--text">
                Please add your details of your claim below.
              </span>
            </v-alert>
          </v-col>
        </v-row>
      </v-form>
    </ValidationObserver>
    <v-row
      v-if="questionPreviousClaim.Value"
      class="mb-6 mt-3 claim-detail-section"
    >
      <v-col cols="12" class="py-0">
        <div
          class="white--text d-flex justify-space-between font-16 font-weight-bold claim-header"
        >
          <div class="claim-detail-text">Claim details</div>
        </div>
        <ValidationObserver ref="observerClaim" v-slot="{ passes }">
          <v-form
            ref="claimDetailForm"
            @submit.prevent="passes(onAddPreviousClaim)"
          >
            <div
              class="d-flex flex-column justify-space-between layoutTableBuilder"
            >
              <v-row>
                <v-col cols="12" xl="7" class="py-0 mt-3">
                  <BaseLabel
                    :text="LABEL_CONSTANTS.PREVIOUS_CLAIM_CLAIMED_UNDER"
                  />
                  <BaseSelect
                    ref="previousClaimClaimedUnder"
                    v-model="previousClaimClaimedUnder"
                    :items="previousClaimClaimedUnderOptions"
                    className="claim-detail-input"
                    data-uiid="PreviousClaimClaimedUnder"
                    :hide-details="false"
                    :selectedDefault="
                      LABEL_CONSTANTS.SELECT_DEFAULT_PLACEHOLDER
                    "
                    :rules="{
                      required: {
                        required: true,
                        fieldLabel:
                          LABEL_CONSTANTS.PREVIOUS_CLAIM_CLAIMED_UNDER,
                      },
                    }"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xl="7" class="py-0">
                  <BaseLabel
                    :text="LABEL_CONSTANTS.PREVIOUS_CLAIM_TYPE_OF_LOSS"
                  />
                  <BaseSelect
                    ref="previousClaimTypeOfLoss"
                    v-model="previousClaimTypeOfLoss"
                    className="claim-detail-input"
                    :items="previousClaimTypeOfLossOptions"
                    data-uiid="PreviousClaimTypeOfLoss"
                    :selectedDefault="
                      LABEL_CONSTANTS.SELECT_DEFAULT_PLACEHOLDER
                    "
                    :hide-details="false"
                    :rules="{
                      required: {
                        required: true,
                        fieldLabel: LABEL_CONSTANTS.PREVIOUS_CLAIM_TYPE_OF_LOSS,
                      },
                    }"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xl="7" class="py-0">
                  <BaseLabel :text="LABEL_CONSTANTS.PREVIOUS_DATE_OF_CLAIM" />
                  <BaseInputDate
                    vid="previousClaimDateOfLoss"
                    ref="previousClaimDateOfLoss"
                    data-uiid="PreviousClaimDateOfLoss"
                    :value="previousClaimDateOfLoss"
                    v-model="previousClaimDateOfLoss"
                    :rules="{
                      required: {
                        required: true,
                        fieldLabel: LABEL_CONSTANTS.PREVIOUS_DATE_OF_CLAIM,
                      },
                      date_valid: {
                        fieldLabel: LABEL_CONSTANTS.PREVIOUS_DATE_OF_CLAIM,
                        errorMessageTemplate: ERROR_INVALID,
                      },
                      regex: {
                        fieldLabel: LABEL_CONSTANTS.PREVIOUS_DATE_OF_CLAIM,
                        errorMessageTemplate: ERROR_INVALID,
                        pattern: DATE_REGEX,
                      },
                      date_in_range_past: {
                        fieldLabel: LABEL_CONSTANTS.PREVIOUS_DATE_OF_CLAIM,
                        max: 5,
                        units: 'years',
                        customMessage: ERROR_PREVIOUS_INVALID_FIVE_YEAR_DATE,
                      },
                    }"
                    styleClass="d2c-date-input claim-detail-input"
                  />
                </v-col>
              </v-row>
              <v-row class="mb-1 mt-4">
                <v-col cols="6" xl="4" class="py-0">
                  <BaseLabel :text="LABEL_CONSTANTS.PREVIOUS_CLAIM_AMOUNT" />
                  <BaseInput
                    vid="previousClaimAmountOfLoss"
                    ref="previousClaimAmountOfLoss"
                    v-model="previousClaimAmountOfLoss"
                    :value="previousClaimAmountOfLoss"
                    data-uiid="PreviousClaimAmountOfLoss"
                    :hide-details="false"
                    moneyFormat
                    className="claim-detail-input"
                    prefix="£"
                    :rules="applicantPreviousClaimAmountRules"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" md="4" class="pa-0">
                  <BaseButton
                    text="ADD"
                    rounded
                    block
                    class="font-weight-bold white--text"
                    :class="
                      $vuetify.breakpoint.mdAndUp ? 'add-button-size' : ''
                    "
                    width="100%"
                    height="48"
                    :color="'#106175'"
                    :fontSize="'font-20'"
                    type="submit"
                  />
                </v-col>
              </v-row>
            </div>
          </v-form>
        </ValidationObserver>

        <div v-if="previousClaimItems.length">
          <BaseTable
            v-if="$vuetify.breakpoint.mdAndUp"
            :tableHeaders="[
              {
                text: 'Claim',
                value: 'PreviousClaimClaimedUnder.Value.text',
              },
              {
                text: 'Description',
                value: 'PreviousClaimTypeOfLoss.Value.text',
              },
              {
                text: 'Date',
                value: 'PreviousClaimDateOfLoss.Value',
              },
              {
                text: 'Value',
                value: 'PreviousClaimAmountOfLoss.Text',
              },
              { text: '', value: 'actions' },
            ]"
            :tableItems="previousClaimItems"
            :tableActions="{
              delete: true,
            }"
            @deleteItem="removePreviousClaimItem"
          />
          <template v-else>
            <div
              class="possession-container mb-4"
              v-for="(item, index) in previousClaimItems"
              :key="index"
            >
              <div class="border-r10 pa-3 mt-5">
                <div class="d-flex justify-space-between">
                  <div
                    class="d-flex flex-grow-1 justify-space-between align-center"
                  >
                    <div class="item-title font-12 pa-1 px-4">
                      {{ item.PreviousClaimClaimedUnder.Value.text }}
                    </div>
                    <h4>
                      {{ item.PreviousClaimDateOfLoss.Value }}
                    </h4>
                  </div>
                </div>
                <div
                  class="d-flex py-4 justify-space-between font-weight-bold font-20 description__wrapper"
                >
                  <h4 class="ml-4">
                    {{ item.PreviousClaimTypeOfLoss.Value.text }}
                  </h4>
                  <h4>
                    {{ item.PreviousClaimAmountOfLoss.Text }}
                  </h4>
                </div>
              </div>
              <div class="justify-center d-flex d-lg-none">
                <BaseButton
                  text="REMOVE"
                  flat
                  rounded
                  small
                  icon="mdi-minus-circle"
                  class="font-20 mt-5"
                  @click="removePreviousClaimItem(index)"
                  :iconColor="'var(--red-500)'"
                  link
                />
              </div>
            </div>
          </template>
        </div>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col class="d-flex">
        <BaseButton
          :text="
            $vuetify.breakpoint.lgAndUp
              ? LABEL_CONSTANTS.CONTINUE_TO_PROPERTY_DETAILS
              : 'CONTINUE'
          "
          rounded
          class="font-weight-bold continue-button"
          height="60"
          :color="'psorange'"
          :textColor="'#000000'"
          :fontSize="'font-20'"
          @click="onSubmit"
          :disabled="!isQuestionNoOfRentalPropertiesValid"
          :min-width="$vuetify.breakpoint.lgAndUp ? '450' : '100%'"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  scrollTop,
  addFieldLabel,
  convertToBool,
  formatCurrency,
  tryGoToNextStep,
} from "@/common/utils";
import numeral from "numeral";
import { EventBus } from "@/common/eventbus.js";
import { ValidationObserver } from "vee-validate";
import { wordsToNumbers } from "@/common/answers.js";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { populateClaimTable, preparePreviousClaimData } from "@/common/claims";

import {
  setItemDataUiids,
  APPLICANT_TITLE_ITEMS,
  NO_OF_RENTAL_PROPERTIES_ITEMS,
  PREVIOUS_CLAIM_TYPE_OF_LOSS_ITEMS,
  PREVIOUS_CLAIM_CLAIMED_UNDER_ITEMS,
} from "@/constants/component.constants";
import { AMOUNT_DEFAULT_FORMAT } from "@/constants/currency-format.constants";
import * as LABEL_CONSTANTS from "@/constants/label.constants";
import {
  ERROR_INVALID,
  ERROR_NAME_INVALID,
  ERROR_MSG_MAX_CHARACTER,
  ERROR_MSG_MAX_CHARACTER_COST_CLAIM,
  ERROR_PREVIOUS_INVALID_CLAIM_AMOUNT,
  ERROR_PREVIOUS_INVALID_FIVE_YEAR_DATE,
} from "@/constants/message.constants.js";
import {
  DATE_REGEX,
  NAME_REGEX,
  FIRST_NUMBER_CHARACTERS_REGEX,
} from "@/constants/regex-patterns.constants";
import { ROUTE_NAME } from "@/constants/route.constants";
import { EXIT_DESTINATION } from "@/constants/common.constants";
import { DIALOG_MODULE, QUESTIONS_MODULE } from "@/store/types/module-types";

import BaseInput from "@/components/BaseComponents/BaseInput.vue";
import BaseLabel from "@/components/BaseComponents/BaseLabel.vue";
import BaseRadio from "@/components/BaseComponents/BaseRadio.vue";
import BaseTable from "@/components/BaseComponents/BaseTable.vue";
import BaseButton from "@/components/BaseComponents/BaseButton.vue";
import BaseSelect from "@/components/BaseComponents/BaseSelect.vue";
import BaseToggle from "@/components/BaseComponents/BaseToggle.vue";
import BaseInputDate from "@/components/BaseComponents/BaseInputDate.vue";
import BaseLabelDialog from "@/components/BaseComponents/BaseLabelDialog.vue";
import BaseAutocomplete from "@/components/BaseComponents/BaseAutocomplete.vue";
import BaseToggleButton from "@/components/BaseComponents/BaseToggleButton.vue";

export default {
  name: "D2CLandlordYourDetailsPage",
  components: {
    ValidationObserver,
    BaseButton,
    BaseInputDate,
    BaseAutocomplete,
    BaseInput,
    BaseLabel,
    BaseSelect,
    BaseToggle,
    BaseToggleButton,
    BaseLabelDialog,
    BaseTable,
    BaseRadio,
  },
  data() {
    return {
      questionApplicant1DoB: {},
      questionApplicant1Forename: {},
      questionApplicant1Surname: {},
      questionApplicant1Title: {},
      questionApplicant1Occupation: {},
      questionApplicant1Industry: {},
      questionSecondApplicantIncluded: {},
      questionApplicant2DoB: {},
      questionApplicant2Forename: {},
      questionApplicant2Surname: {},
      questionApplicant2Title: {},
      questionApplicant2Occupation: {},
      questionApplicant2Industry: {},
      questionPreviousLandlordsCover: {},
      questionNoOfRentalProperties: {},
      questionUnapprovedMortgageApplication: {},
      questionPreviousClaim: {},
      questionPreviousClaimValues: {},
      previousClaimClaimedUnder: "",
      previousClaimTypeOfLoss: "",
      previousClaimDateOfLoss: "",
      previousClaimAmountOfLoss: "",
      previousClaimItems: [],
      isClaimFormValid: true,
      NAME_REGEX,
      FIRST_NUMBER_CHARACTERS_REGEX,
      DATE_REGEX,
      AMOUNT_DEFAULT_FORMAT,
      LABEL_CONSTANTS,
      ERROR_PREVIOUS_INVALID_FIVE_YEAR_DATE,
      ERROR_PREVIOUS_INVALID_CLAIM_AMOUNT,
      ERROR_NAME_INVALID,
      ERROR_MSG_MAX_CHARACTER,
      ERROR_INVALID,
      ERROR_MSG_MAX_CHARACTER_COST_CLAIM,
      APPLICANT_TITLE_ITEMS,
      NO_OF_RENTAL_PROPERTIES_ITEMS,
      PREVIOUS_CLAIM_TYPE_OF_LOSS_ITEMS,
      PREVIOUS_CLAIM_CLAIMED_UNDER_ITEMS,
      applicantDateOfBirthRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          date_valid: {
            errorMessageTemplate: ERROR_INVALID,
          },
          regex: {
            errorMessageTemplate: ERROR_INVALID,
            pattern: DATE_REGEX,
          },
          age_in_range: {
            min: 18,
            max: 120,
          },
        },
        LABEL_CONSTANTS.DATE_OF_BIRTH_LABEL
      ),
      applicantFirstNameRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          max: {
            length: 50,
            errorMessageTemplate: ERROR_MSG_MAX_CHARACTER,
          },
          min_length: {
            length: 2,
          },
          regex: {
            pattern: NAME_REGEX,
            customMessage: ERROR_NAME_INVALID,
          },
        },
        LABEL_CONSTANTS.FIRST_NAME_LABEL
      ),
      applicantLastNameRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          max: {
            length: 100,
            errorMessageTemplate: ERROR_MSG_MAX_CHARACTER,
          },
          min_length: {
            length: 2,
          },
          regex: {
            pattern: NAME_REGEX,
            customMessage: ERROR_NAME_INVALID,
          },
        },
        LABEL_CONSTANTS.LAST_NAME_LABEL
      ),
      applicantPreviousClaimAmountRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          max_currency_length: {
            length: 10,
            errorMessageTemplate: ERROR_MSG_MAX_CHARACTER_COST_CLAIM,
          },
          regex: {
            pattern: FIRST_NUMBER_CHARACTERS_REGEX,
            customMessage: ERROR_PREVIOUS_INVALID_CLAIM_AMOUNT,
          },
        },
        LABEL_CONSTANTS.PREVIOUS_CLAIM_AMOUNT
      ),
      vidObject: {
        postCode: "InsuredAddressPostCode",
        street: "InsuredAddressStreet",
        district: "InsuredAddressDistrict",
        town: "InsuredAddressTown",
        county: "InsuredAddressCounty",
      },
    };
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, [
      "quoteResponse",
      "questionMap",
      "restoringLastStep",
    ]),
    ...mapGetters(QUESTIONS_MODULE, [
      "isExpired",
      "allIndustries",
      "allOccupations",
      "repeatingQuestionSetIndex",
    ]),
    applicant1TitleOptions() {
      return setItemDataUiids("Applicant1Title", this.APPLICANT_TITLE_ITEMS);
    },
    applicant2TitleOptions() {
      return setItemDataUiids("Applicant2Title", this.APPLICANT_TITLE_ITEMS);
    },
    noRetailRentalOptions() {
      return setItemDataUiids(
        "NoOfRentalProperties",
        this.NO_OF_RENTAL_PROPERTIES_ITEMS
      );
    },
    previousClaimTypeOfLossOptions() {
      return setItemDataUiids(
        "PreviousClaimTypeOfLoss",
        this.PREVIOUS_CLAIM_TYPE_OF_LOSS_ITEMS.map((x) => ({
          ...x,
          Value: x.value,
        })) // adding Value field to reuse logic formatClaimData
      );
    },
    previousClaimClaimedUnderOptions() {
      return setItemDataUiids(
        "PreviousClaimClaimedUnder",
        this.PREVIOUS_CLAIM_CLAIMED_UNDER_ITEMS.map((x) => ({
          ...x,
          Value: x.value, // adding Value field to reuse logic formatClaimData
        }))
      );
    },
    isQuestionNoOfRentalPropertiesValid() {
      return (
        numeral(
          wordsToNumbers(this.questionNoOfRentalProperties.Value)
        ).value() < 11
      );
    },
  },
  beforeMount() {
    this.onSetupAndLoadSavedData();
    scrollTop();
  },
  async mounted() {
    this.setCurrentRefObserverForm(this.$refs.observerFormDetails);
    if (!this.restoringLastStep) {
      return;
    }

    // work around running validate before the data has been added to input
    setTimeout(async () => {
      tryGoToNextStep(
        this.$refs.observerFormDetails,
        async (form) =>
          (await form.validate()) &&
          (!this.questionPreviousClaim.Value || this.previousClaimItems.length),
        ROUTE_NAME.LANDLORDS.D2C.PROPERTY_DETAILS
      );
    }, 0);
  },
  watch: {
    "questionPreviousClaim.Value"(value) {
      if (value !== undefined && !value) {
        this.isClaimFormValid = true;
        this.previousClaimItems = [];
        this.removePreviousClaimData();
      }
    },
    "quoteResponse.Answers"() {
      this.populateClaimsValue();
    },
  },
  methods: {
    ...mapMutations(DIALOG_MODULE, ["showModal"]),
    ...mapActions(QUESTIONS_MODULE, [
      "saveProgress",
      "increaseRepeatingQuestionSetIndex",
      "setRestoringLastStep",
      "setupReceivePreviousClaimData",
      "preparePreviousClaimData",
      "setIsExpiredFlag",
      "toggleGlobalSaveAndExitDialog",
      "setCurrentRefObserverForm",
    ]),

    async onSetupAndLoadSavedData() {
      this.questionApplicant1DoB = this.questionMap.Applicant1DoB;
      this.questionApplicant1Forename = this.questionMap.Applicant1Forename;
      this.questionApplicant1Surname = this.questionMap.Applicant1Surname;
      this.questionApplicant1Title = this.questionMap.Applicant1Title;
      this.questionApplicant1Occupation = this.questionMap.Applicant1Occupation;
      this.questionApplicant1Industry = this.questionMap.Applicant1Industry;
      this.questionSecondApplicantIncluded =
        this.questionMap.SecondApplicantIncluded;
      this.questionSecondApplicantIncluded.Value = convertToBool(
        this.questionSecondApplicantIncluded.Value
      );
      this.questionApplicant2DoB = this.questionMap.Applicant2DoB;
      this.questionApplicant2Forename = this.questionMap.Applicant2Forename;
      this.questionApplicant2Surname = this.questionMap.Applicant2Surname;
      this.questionApplicant2Title = this.questionMap.Applicant2Title;
      this.questionApplicant2Occupation = this.questionMap.Applicant2Occupation;
      this.questionApplicant2Industry = this.questionMap.Applicant2Industry;
      this.questionPreviousLandlordsCover =
        this.questionMap.PreviousLandlordsCover;
      this.questionPreviousLandlordsCover.Value = convertToBool(
        this.questionPreviousLandlordsCover.Value
      );
      this.questionNoOfRentalProperties = this.questionMap.NoOfRentalProperties;
      this.questionUnapprovedMortgageApplication =
        this.questionMap.UnapprovedMortgageApplication;
      this.questionUnapprovedMortgageApplication.Value = convertToBool(
        this.questionUnapprovedMortgageApplication.Value
      );
      this.questionPreviousClaimValues = this.questionMap.PreviousClaimValues;
      this.questionPreviousClaim = this.questionMap.PreviousClaim;
      this.questionPreviousClaim.Value = convertToBool(
        this.questionPreviousClaim.Value
      );

      if (this.questionPreviousClaim?.Value === true) {
        this.populateClaimsValue();
      }
    },
    populateClaimsValue() {
      this.questionPreviousClaimValues.Value = [];
      populateClaimTable(
        this.$store.state.questions,
        this.quoteResponse.Answers,
        this.questionPreviousClaimValues
      );
      this.previousClaimItems = [...this.questionPreviousClaimValues.Value];
    },
    async onSubmit() {
      const isValidForm = await this.$refs.observerFormDetails.validate();
      this.isClaimFormValid = !(
        this.questionPreviousClaim.Value && !this.previousClaimItems.length
      );

      if (!isValidForm || !this.isClaimFormValid) {
        EventBus.$emit("validation-error", "Validation error occurred");
        return;
      }

      this.prepareDataForSubmit();

      this.saveProgress().then(() => {
        this.$router.push({
          name: ROUTE_NAME.LANDLORDS.D2C.PROPERTY_DETAILS,
        });
      });
    },

    saveAndExit() {
      this.prepareDataForSubmit();
      this.toggleGlobalSaveAndExitDialog(EXIT_DESTINATION.landlordWelcomePage);
    },
    prepareDataForSubmit() {
      preparePreviousClaimData(
        this.questionPreviousClaim.Value,
        this.questionPreviousClaimValues,
        this.repeatingQuestionSetIndex,
        this.previousClaimItems
      );
      this.setupSubmitApplicant2Data();
      sessionStorage.removeItem("isNewQuoteFromExpiredQuote");
    },
    setupSubmitApplicant2Data() {
      if (!this.questionSecondApplicantIncluded.Value) {
        this.questionApplicant2DoB.Value = null;
        this.questionApplicant2Forename.Value = null;
        this.questionApplicant2Surname.Value = null;
        this.questionApplicant2Title.Value = null;
        this.questionApplicant2Occupation.Value = null;
        this.questionApplicant2Industry.Value = null;
      }
    },
    removePreviousClaimData() {
      this.questionPreviousClaimValues.Value = [];
    },
    async onAddPreviousClaim() {
      const isValid = await this.$refs.claimDetailForm.validate();
      if (!isValid) {
        return;
      }
      const previousClaimClaimedUnderValue =
        this.previousClaimClaimedUnderOptions.find(
          (item) => item.value === this.previousClaimClaimedUnder
        );
      const previousClaimTypeOfLossValue =
        this.previousClaimTypeOfLossOptions.find(
          (item) => item.value === this.previousClaimTypeOfLoss
        );
      this.previousClaimItems.push({
        PreviousClaimClaimedUnder: {
          Value: previousClaimClaimedUnderValue,
        },
        PreviousClaimTypeOfLoss: {
          Value: previousClaimTypeOfLossValue,
        },
        PreviousClaimDateOfLoss: {
          Value: this.previousClaimDateOfLoss,
        },
        PreviousClaimAmountOfLoss: {
          Value: this.previousClaimAmountOfLoss,
          Text: formatCurrency(this.previousClaimAmountOfLoss),
        },
      });
      this.resetPreviousClaimForm();
    },
    resetPreviousClaimForm() {
      this.$refs.previousClaimClaimedUnder.$children[0].reset();
      this.$refs.previousClaimTypeOfLoss.$children[0].reset();
      this.$refs.previousClaimDateOfLoss.$children.forEach((children) => {
        children.$children[0].innerValue = "";
        children.$children[0].reset();
      });
      this.$refs.previousClaimAmountOfLoss.$children[0].reset();
      this.$refs.claimDetailForm.reset();
    },
    removePreviousClaimItem(index) {
      this.previousClaimItems.splice(index, 1);
    },
    backToCoverType() {
      this.$router.push({ name: ROUTE_NAME.LANDLORDS.D2C.COVER_TYPE });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/d2c/claim-detail-section.scss";

.d2c-your-detail__container {
  .select__wrapper {
    max-width: 100% !important;
    margin-bottom: 12px;
  }

  .second-applicant-included-field {
    :deep(.v-icon) {
      margin-right: 16px !important;
    }

    :deep(.v-btn) {
      padding: 4px 4px !important;
    }
  }

  :deep(.v-text-field__details) {
    padding-left: 0 !important;
    position: unset;
  }

  .radio-renta-propertise {
    :deep(.v-input) {
      max-width: unset !important;
    }
  }
}

@media screen and (min-width: $grid-breakpoints-lg) {
  .title-select {
    max-width: 304px;
  }

  :deep(.v-input) {
    max-width: 440px;
  }

  :deep(.d2c-date-input) {
    max-width: 440px;
  }

  :deep(.sub-help-text) {
    min-width: 584px;
  }
}
</style>
